<template>
    <div class="pagination-container">
        <div class="pagination" :class="containerCssClasses">
            <span
                v-for="(slide, i) in items"
                class="pagination-item"
                :class="[itemCssClasses, {'pagination-item-active': (index == i)}]"
                :data-pagination="i"
                :key="slide.id"
                @click="onClick"
            ></span>
        </div>
    </div>
</template>

<script>
import { propsStringEnumValidator } from "@/libs/utils";
const alignValidator = propsStringEnumValidator(["v", "h"]);

export default {
    props: {
        items: {
            type: Array,
            required: true
        },

        index: {
            type: Number,
            required: true
        },

        align: {
            type: String,
            default: "h",
            validator: alignValidator
        }
    },
    computed: {
        itemCssClasses: function() {
            const arr = [];
            if (this.align == "h") arr.push("pagination-item-horizontal");
            else if (this.align == "v") arr.push("pagination-item-vertical");
            return arr;
        },
        containerCssClasses: function() {
            const arr = [];
            if (this.align == "h") arr.push("pagination-horizontal");
            else if (this.align == "v") arr.push("pagination-vertical");
            return arr;
        }
    },
    methods: {
        onClick(event) {
            const pagIndex = Number(event.target.dataset.pagination);
            this.$emit("pagclick", {
                pagIndex
            });
        }
    }
};
</script>

<style lang="scss" scoped>

.pagination-container{
    display: inline;
}

.pagination {
    display: inline-flex;
    padding: 20px 0;

    &-horizontal {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    &-vertical {
    }
}

.pagination-item {
    width: 10px;
    height: 10px;
    display: inline-block;
    background: rgb(180, 180, 180);
    border-radius: 100px;
    cursor: pointer;

    &-active {
        background-color: #000000;
    }
    &-vertical {
        margin: 20 0px;
    }
    &-horizontal {
        margin: 0 20px;
    }
}
</style>